import styled from 'styled-components/macro';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

export const Tooltip = styled(TooltipPrimitive.Root)``;

export const Provider = styled(TooltipPrimitive.Provider)``;
